import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AppLinkRedirect from "../components/AppLinkRedirect";
import {
  buildDeepLink,
  decodeAndValidatePublicId
} from "../utils/appLinks";

function PostRedirect() {
  const { postId: routePostId = "" } = useParams();
  const postId = decodeAndValidatePublicId(routePostId);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "View a post on Mondoway | Mondoway";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <AppLinkRedirect
      deepLinkUrl={postId ? buildDeepLink("post", postId) : null}
      invalid={!postId}
      openingTitle="Opening this post in Mondoway..."
      invalidTitle="This post is unavailable."
      invalidDescription="This post link is invalid, or the post may no longer be available."
    />
  );
}

export default PostRedirect;
